<template>
    <b-carousel-slide>
        <template #img>
            <h6 class="font-light">{{ productType }}</h6>
            <h5>{{ productTitle }}</h5>
            <p v-html="htmlProductDescription"></p>
            <div class="mb-2" v-if="productBtnLabel">

                <b-button @click="$emit('submit', { url: productCtaLink, type: productType, id: productId, product: product})"  type="button" variant="cta" class="button-cta mt-4">
                    <span v-html="productBtnLabel"></span>
                </b-button>
            
            </div>
            
        </template>
    </b-carousel-slide>
</template>


<script>
import Vue from 'vue';
export default {
  name: "CardSliderItem",
  emits: ['submit'],
  props: {
    product:{
      type: Object,
    },
    productId:{
        type: String,
        default:''
    },
    productTitle: {
        type: String,
        default:''
    },
    productType: {
        type: String,
        default:''
    },
    productAction: {
        type: String,
        default:''
    },
    productCtaLink:  {
        type: String,
        default:''
    },
    productBtnLabel: {
        type: String,
        default:''
    },
    productDescription: {
        type: String,
        default:''
    },
    id: {
        type: String,
        default: () => Vue.utils.generateRandomHash(10)
    }
  },
  computed: {
    htmlProductDescription() {
      const src = this.productDescription || '';
      if (!src) return '';
      const trimmed = src.trim();
      const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(trimmed);
      if (looksLikeHtml) return src;
      const blocks = trimmed.split(/\n\s*\n/);
      const out = blocks.map(block => {
        const lines = block.split(/\n/);
        if (lines.every(l => /^\s*\d+\.\s+/.test(l))) {
          const items = lines.map(l => `<li>${this.__mdInline(l.replace(/^\s*\d+\.\s+/, ''))}</li>`).join('');
          return `<ol>${items}</ol>`;
        }
        if (lines.every(l => /^\s*[-*]\s+/.test(l))) {
          const items = lines.map(l => `<li>${this.__mdInline(l.replace(/^\s*[-*]\s+/, ''))}</li>`).join('');
          return `<ul>${items}</ul>`;
        }
        const headingMatch = block.match(/^\s*(#{1,6})\s+(.+)$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const text = this.__mdInline(headingMatch[2]);
          return `<h${level}>${text}</h${level}>`;
        }
        return `<p>${this.__mdInline(lines.join('\n')).replace(/\n/g, '<br/>')}</p>`;
      });
      return out.join('');
    }
  },
  methods: {
    __mdInline(text) {
      let html = text || '';
      html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
      html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
      html = html.replace(/__([^_]+)__/g, '<strong>$1</strong>');
      html = html.replace(/(^|[^*])\*([^*]+)\*(?!\*)/g, '$1<em>$2</em>');
      html = html.replace(/(^|[^_])_([^_]+)_(?!_)/g, '$1<em>$2</em>');
      return html;
    }
  }
}
</script>